import styled from "styled-components";
import { margin } from "../../globalStyle";

export const Wrapper = styled.div `
  padding-top: ${margin.mheader};


`

export const Content = styled.div `
  padding: 2rem;
`